
class CssSolarSystemCtrl{

};

export default CssSolarSystemCtrl;


// WEBPACK FOOTER //
// ./app/scripts/controllers/csssolarsystem.js